<template>
    <label :class="classes">
        <input :id="`field-${name}-input`"
               :name="name"
               :aria-labelledby="`field-${name}-label`"
               ref="input"
               :value="value"
               @input="updateValue"
               :placeholder="placeholder"
               class="field-input"
               type="search"
               autocomplete="nope"
               spellcheck="false"
        >
        <span :id="`field-${name}-label`"
              class="field-label"
              aria-hidden="true"
              v-if="label"
        >
            {{ label }}
        </span>
        <icon class="search-icon" name="search"/>
    </label>
</template>

<script>
  import Icon      from '../Layout/Icon';
  import TextField from './TextField';

  export default {
    name:       'SearchField',
    components: { Icon },
    extends:    TextField,

    computed: {
      classes () {
        return {
          ...this.baseClasses,
          'field-type-basic':  true,
          'field-type-search': true,
        };
      },
    },
  };
</script>

<style scoped>
    .field-input::-webkit-search-decoration,
    .field-input::-webkit-search-cancel-button,
    .field-input::-webkit-search-results-button,
    .field-input::-webkit-search-results-decoration {
        display: none;
    }

    .search-icon {
        order:       3;
        position:    absolute;
        right:       0;
        top:         0.75rem;
        font-size:   1.2rem;
        opacity:     0.75;
        user-select: none;
        transition:  opacity 125ms;
    }

    .field:focus-within .search-icon {
        opacity: 0;
    }
</style>
